import { render, staticRenderFns } from "./CharacterImage.vue?vue&type=template&id=4a8f2610&scoped=true&"
import script from "./CharacterImage.vue?vue&type=script&lang=js&"
export * from "./CharacterImage.vue?vue&type=script&lang=js&"
import style0 from "./CharacterImage.vue?vue&type=style&index=0&id=4a8f2610&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8f2610",
  null
  
)

export default component.exports